import React, { useState } from 'react'
import clsx from 'clsx'
import { CollapseButton } from './collapse-button'
import { CollapseContent } from './collapse-content'
import { CollapseContext } from './collapse-context'

import * as styles from './collapse.module.scss'

type Props = React.ComponentProps<'div'> & {
  open?: boolean
}

const BaseCollapse = ({
  className,
  children,
  open = false,
  ...props
}: Props) => {
  const state = useState(open)
  const [isOpen] = state
  return (
    <CollapseContext.Provider value={state}>
      <div
        className={clsx(styles.collapse, isOpen && styles.open, className)}
        {...props}
      >
        {children}
      </div>
    </CollapseContext.Provider>
  )
}

export const Collapse = Object.assign(BaseCollapse, {
  Button: CollapseButton,
  Content: CollapseContent,
})
